import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FlexStack } from '~/components/atomic';

export const AvarturnIFrameName = 'sdk-iframe';

export const Container = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 100%;
    height: 100%;
    /* padding-top: ${theme.layout.chat_header_height}; */
  `}
`;

export const ViewerWrapper = styled.div`
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  ${`.${AvarturnIFrameName}`} {
    width: 100%;
    height: 100%;
  }
`;

export const FinishButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    position: absolute;
    top: calc(${theme.layout.chat_header_height} + 8px);
    right: 8px;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 36px;
    padding: 8px;
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 16px;
    background: ${theme.themeColor.main_1};
    color: ${theme.content.content_dark_1};
    gap: 4px;
    ${theme.fontStyle.title.section18_medium};
  `}
`;

export const AssetContainer = styled.div`
  display: flex;
  position: absolute;
  z-index: 1;
  bottom: 32px;
  flex-direction: column;
  width: 100%;
  padding: 0 16px;
  gap: 8px;
`;

export const AssetWrapper = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    width: 100%;
    max-height: 220px;
    padding: 16px;
    overflow-y: auto;
    border-radius: 16px;
    background: ${theme.backgroundColor.bg_light_5_alpha};
    gap: 4px;
    backdrop-filter: blur(25px);
    ${theme.mixins.scroll.default};

    &::-webkit-scrollbar {
      height: 4px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: ${theme.backgroundColor.bg_light_4}; /* 스크롤바 색상 */
    }

    &::-webkit-scrollbar-track {
      background-color: transparent; /* 스크롤바 트랙 색상 */
    }
  `}
`;

export const AssetWrapperFlex = styled(FlexStack)`
  ${({ theme }) => css`
    margin-top: 4px;
    padding: 8px 16px;
    border-radius: 16px;
    background: ${theme.backgroundColor.bg_light_5_alpha};
    backdrop-filter: blur(25px);
  `}
`;
export const AssetTypeWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    padding: 4px;
    overflow-x: auto;
    border-radius: 16px;
    background: ${theme.backgroundColor.bg_light_5_alpha};
    backdrop-filter: blur(25px);
  `}
`;

export const AssetTypeButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    border-radius: 14px;
    color: ${theme.content.content_light_1};
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
    gap: 8px;

    ${theme.fontStyle.text.body14_medium};
    text-transform: capitalize;

    &.on {
      background: ${theme.backgroundColor.bg_light_5_alpha};
    }
  `}
`;
